/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Copy_LabelInputs */

const en_options_api_keys_copy_label = /** @type {(inputs: Options_Api_Keys_Copy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy to clipboard`)
};

const fr_options_api_keys_copy_label = /** @type {(inputs: Options_Api_Keys_Copy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier dans le presse-papiers`)
};

const de_options_api_keys_copy_label = /** @type {(inputs: Options_Api_Keys_Copy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In die Zwischenablage kopieren`)
};

const it_options_api_keys_copy_label = /** @type {(inputs: Options_Api_Keys_Copy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia negli appunti`)
};

const ru_options_api_keys_copy_label = /** @type {(inputs: Options_Api_Keys_Copy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировать в буфер обмена`)
};

const es_options_api_keys_copy_label = /** @type {(inputs: Options_Api_Keys_Copy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar al portapapeles`)
};

const zh_cn2_options_api_keys_copy_label = /** @type {(inputs: Options_Api_Keys_Copy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制到剪贴板`)
};

const ja_options_api_keys_copy_label = /** @type {(inputs: Options_Api_Keys_Copy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリップボードにコピー`)
};

const hi_options_api_keys_copy_label = /** @type {(inputs: Options_Api_Keys_Copy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्लिपबोर्ड पर कॉपी करें`)
};

const pt_pt2_options_api_keys_copy_label = /** @type {(inputs: Options_Api_Keys_Copy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar para a área de transferência`)
};

/**
* | output |
* | --- |
* | "Copy to clipboard" |
*
* @param {Options_Api_Keys_Copy_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_copy_label = /** @type {((inputs?: Options_Api_Keys_Copy_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Copy_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_api_keys_copy_label(inputs)
	if (locale === "de") return de_options_api_keys_copy_label(inputs)
	if (locale === "it") return it_options_api_keys_copy_label(inputs)
	if (locale === "ru") return ru_options_api_keys_copy_label(inputs)
	if (locale === "es") return es_options_api_keys_copy_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_api_keys_copy_label(inputs)
	if (locale === "ja") return ja_options_api_keys_copy_label(inputs)
	if (locale === "hi") return hi_options_api_keys_copy_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_api_keys_copy_label(inputs)
	return en_options_api_keys_copy_label(inputs)
});